import { render, staticRenderFns } from "./Project_v2.vue?vue&type=template&id=f69a73fe&scoped=true"
import script from "./Project_v2.vue?vue&type=script&lang=js"
export * from "./Project_v2.vue?vue&type=script&lang=js"
import style0 from "./Project_v2.vue?vue&type=style&index=0&id=f69a73fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f69a73fe",
  null
  
)

export default component.exports